import { ActionTree } from 'vuex';
import authenticationStateType from './authenticationStateType';

export const actions: ActionTree<authenticationStateType, unknown> = {
  setTeamMemberGrantedPermissions({ commit }, permissions) {
    commit('SET_GRANTED_PERMISSIONS', permissions);
  },
};
